

































































import Vue from "vue";
import FactBtn from "../Utilities/FactBtn.vue";

export default Vue.extend({
  name: "QuickLinks",
  data: () => ({
    modalVisible: false as boolean,
    modalMode: "" as string
  }),
  components: {
    FactBtn
  },
  methods: {
    openModal(type: string) {
      this.modalVisible = true;
      this.modalMode = type;
    },
    openExternalLink(url: string) {
      window.open(url, "_blank");
    }
  }
});
